import {makeAutoObservable} from 'mobx';
import AuthRepository from '../../data/repositories/AuthRepository';
import OrganizationRepository from '../../data/repositories/OrganizationRepository';
import UserRepository from '../../data/repositories/UserRepository';
import SubscriptionRepository from '../../data/repositories/SubscriptionRepository';

class NavigationStore {
  private authRepo = new AuthRepository();
  private organizationRepo = new OrganizationRepository();
  private userRepo = new UserRepository();
  private subscriptionRepository = new SubscriptionRepository();

  private storageUsed = 0;
  private usersUsed = 0;

  constructor() {
    makeAutoObservable(this);
  }

  public async getUserOrgPermissions(organizationId: string) {
    const result = await this.authRepo.getUserOrgPermissions(organizationId);
    if (result.success && result.data) {
      return result.data;
    }
    return [];
  }

  public async getOrgSubscriptionPermissions(organizationId: string) {
    const result =
      await this.subscriptionRepository.getSubscriptionPermissions(
        organizationId,
      );
    if (result.success && result.data) {
      return result.data;
    }
  }

  public async getOrganizationDetails(organizationId: string) {
    const result =
      await this.organizationRepo.getOrganizationDetails(organizationId);
    if (result.success && result.data) {
      this.storageUsed = result.data.totalLibraryMediaFileSizesInMb;
      return result.data;
    }
  }

  public async getOrganizationUsersCount(organizationId: string) {
    const result =
      await this.organizationRepo.getOrganizationUsersCount(organizationId);
    if (result.success && result.data) {
      this.usersUsed = result.data?.count || 0;
      return result.data;
    }
  }

  public async getOrganizationSubscription(organizationId: string) {
    const result =
      await this.subscriptionRepository.getOrganizationSubscription(
        organizationId,
      );
    if (result.success && result.data) {
      return result.data;
    }
  }

  public async getUserInfo() {
    const result = await this.userRepo.getUserInfo();
    if (result.success && result.data) {
      return result.data;
    }
  }

  public getStorageUsed() {
    return this.storageUsed;
  }

  public getUsersUsed() {
    return this.usersUsed;
  }
}

export default NavigationStore;
